import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';
import { Produto, ProdutoRevisaoLote } from 'src/app/consts/produtos';
import { ConsultaProdutoService } from 'src/app/services/consulta-produto.service';
import { ErrorPageComponent } from 'src/app/shared/custom-components/error-page/error-page.component';
import { SearchPageComponent } from 'src/app/shared/custom-components/search-page/search-page.component';

@Component({
  selector: 'app-alterar-lote',
  templateUrl: './alterar-lote.component.html',
  styleUrls: ['./alterar-lote.component.css']
})
export class AlterarLoteComponent implements OnInit {

 FormAlterarProduto: FormGroup;

 ListaDeProdutos: Array<ProdutoRevisaoLote>
  selectStatus = [
    { Id: 0, Status: 'Revisão Pendente' },
    { Id: 1, Status: 'Revisado' },
    { Id: 2, Status: 'Atualização pendente' },
    { Id: 3, Status: 'Bloqueado' },
  ];

  closeDialog = false

  constructor(
    @Inject(MAT_DIALOG_DATA) data,
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    public consultaProdutoService: ConsultaProdutoService
  ) {

    this.ListaDeProdutos = data.Produtos
    this.FormAlterarProduto = this.formBuilder.group({
      CategoriaNova: [null],
      idCategoriaNova: [null],
      Status: null,
    });

  }

  ngOnInit() {
    this.montaSelectStatus(this.FormAlterarProduto.value);

  }

  pesquisarCategorias() {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.data = {
      tabela: 'Categorias',
    };

    this.dialog
      .open(SearchPageComponent, dialogConfig)
      .afterClosed()
      .subscribe((categoriaEscolhida) => {
        if (categoriaEscolhida) {
          this.FormAlterarProduto.patchValue({
            idCategoriaNova: categoriaEscolhida.Id,
            CategoriaNova: categoriaEscolhida.Nome,
          });

          this.selectStatus = [
            {
              Id: 2,
              Status: 'Atualização Pendente'
            }
          ]

          this.FormAlterarProduto.patchValue({
            Status: 2
          })
          console.log(this.FormAlterarProduto.value)
        }
      });

  }

  montaSelectStatus(produto) {
    switch (produto.Status) {
      case 0:
        this.selectStatus = [{ Id: 0, Status: 'Revisão Pendente' }];
        break;

      case 1:
        this.selectStatus = [
          {
            Id: 1,
            Status: 'Revisado',
          },
          {
            Id: 2,
            Status: 'Atualização pendente',
          },
          {
            Id: 3,
            Status: 'Bloqueado',
          },
        ];
        break;

      case 2:
        this.selectStatus = [
          {
            Id: 2,
            Status: 'Atualização Pendente'
          },
          {
            Id: 3,
            Status: 'Bloqueado',
          },
        ];
        break;
      case 3:
        this.selectStatus = [
          {
            Id: 3,
            Status: 'Bloqueado'
          },
          {
            Id: 2,
            Status: 'Atualização pendente',
          },
        ];
        break;
    }
  }

  alterarLote() {

    const novaLista: any[] = this.ListaDeProdutos.map((produto: ProdutoRevisaoLote) => ({
      CategoriaId: this.FormAlterarProduto.value.idCategoriaNova,
      Status: 2,
      ProdutoId: produto.ProdutoId,
      ClienteId: produto.ClienteId
    }))

    console.log(novaLista)

    firstValueFrom(this.consultaProdutoService.alterarLoteProduto(novaLista))
      .then(response => {
        if (response) {
          console.log(response)
          this.abrirPaginaErro('interno', `${this.ListaDeProdutos.length} produtos alterados para a categoria ${this.FormAlterarProduto.value.CategoriaNova} e Status para Atualização Pendente`)
          this.closeDialog = true
        }
      }).catch((err: HttpErrorResponse) => {
        this.abrirPaginaErro('interno', err.message)
      })
  }

  abrirPaginaErro(tipo, mensagem) {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.data = {
      tipo: tipo,
      mensagem: mensagem,
    };

    this.dialog.open(ErrorPageComponent, dialogConfig);
  }

}
